import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default (
  <Route key="/consumer/features/face-editor" element={<DefaultConsumerLayout />}>
    <Route path="consumer/features/face-editor" element={<AsyncPage />} />
  </Route>
);
